/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Select from 'react-select'
import Swal from 'sweetalert2'

function ManageHKT() {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [selectedProperty, setSelectedProperty] = useState({})
    const [selectedRoomType, setSelectedRoomType] = useState({})
    const [properties, setProperties] = useState([])
    const [roomTypes, setRoomTypes] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [draggableIndex, setDraggableIndex] = useState(null)
    // create
    const handleCreate = () => {
        navigate('/create-mapping')
    }

    // fetch data 
    async function fetchList() {

        try {
            const response = await nbrApi.get(`/get_mhkt_list?properties_id=${selectedProperty?.value}&roomtypes_id=${selectedRoomType?.value}`)

            const data = response.data
            setData(data)

        } catch (error) {
            console.error('Error fetching data:', error.message)
        }
    }

    // Init
    useEffect(() => {
        if (selectedProperty?.value && selectedRoomType?.value) {
            fetchList()
        }
    }, [selectedProperty, selectedRoomType])

    // get properties
    const getProperties = async () => {
        try {
            const response = await nbrApi.post('/listproperties')

            const data = response.data
            setProperties(data?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.property_name
                }
            }))
        } catch (error) {
            console.error('Error fetching data:', error.message)
        }
    }

    // search
    const handleSearch = () => {

    }

    // get room types
    const getRoomTypes = async () => {
        try {
            const response = await nbrApi.get(`/getroomtypes?properties_id=${selectedProperty?.value}`)

            const data = response.data

            let modified_data = data?.map(e => {
                return {
                    ...e,
                    value: e?.rt_id,
                    label: e?.room_type_name
                }
            })
            setRoomTypes(modified_data)
        } catch (error) {
            console.error(error)
        }
    }

    // when selectedProperty change
    useEffect(() => {
        if (selectedProperty?.value) {
            getRoomTypes()
        }
    }, [selectedProperty])

    // init
    useEffect(() => {
        getProperties()
    }, [])


    // property change
    const handlePropertyChange = (value) => {
        setSelectedProperty(value)
        setSelectedRoomType({})
        localStorage.setItem('selectedProperty', JSON.stringify(value))
        localStorage.setItem('selectedRoomType', JSON.stringify({}))
    }

    // room change
    const handleRoomChange = (value) => {
        setSelectedRoomType(value)
        localStorage.setItem('selectedRoomType', JSON.stringify(value))
    }

    // default select from local store
    useEffect(() => {
        if (properties?.length > 0) {
            let property = JSON.parse(localStorage.getItem('selectedProperty')) || null
            let roomType = JSON.parse(localStorage.getItem('selectedRoomType')) || null

            setSelectedProperty(property)
            setSelectedRoomType(roomType)
        }
    }, [properties])

    // select style
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: '300px',
        }),
        menu: (provided, state) => ({
            ...provided,
            width: '300px', // Adjust the width as needed
        }),
    };


    // Drag and Drop functionality
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('index', index);
        setDraggableIndex(index)
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = async (e, newIndex) => {
        const oldIndex = e.dataTransfer.getData('index');
        const newData = [...data];
        const [draggedItem] = newData.splice(oldIndex, 1);
        newData.splice(newIndex, 0, draggedItem);

        let key_id = data?.[oldIndex]?.['mhkt_id']
        let key_sequence = data?.[oldIndex]?.['sequence']
        let insert_sequence = data?.[newIndex]?.['sequence']

        if (key_id && key_sequence && insert_sequence) {
            setLoading(true)
            // Make the API call using the dynamic values
            try {
                const response = await nbrApi.get(`/resequence_map?properties_id=${selectedProperty?.value}&roomtypes_id=${selectedRoomType?.value}&key_id=${key_id}&key_sequence=${key_sequence}&insert_sequence=${insert_sequence}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })

                const data = response.data
                setData(data)
                setLoading(false)

            } catch (error) {
                console.error('Error fetching data:', error.message)
                setLoading(false)

            }
        }
        setDraggableIndex(null)
    };


    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Manage Housekeeping Requests</h4>
                        <button type='button' onClick={handleCreate} className='btn btn-primary btn-sm'>Create New Mapping</button>
                    </div>
                    <div className="card-header d-block d-lg-flex justify-content-center align-items-center">
                        <div className='form-group'>
                            <label className='text-secondary'>Property : </label>
                            <Select
                                className='p-0 col-lg-3'
                                options={properties}
                                value={selectedProperty}
                                placeholder={'Select Property'}
                                onChange={(value) => handlePropertyChange(value)}
                                isSearchable
                                isDisabled={properties?.length === 0}
                                styles={customStyles}
                            />
                        </div>

                        <div className='form-group mx-o mx-lg-2'>
                            <label className='mt-3 mt-lg-0 text-secondary'>Room Type : </label>
                            <Select
                                className='p-0 col-lg-3'
                                options={roomTypes}
                                value={selectedRoomType}
                                placeholder={'Select Room Type'}
                                isSearchable
                                onChange={(value) => handleRoomChange(value)}
                                isDisabled={roomTypes?.length === 0}
                                styles={customStyles}
                            />

                        </div>
                    </div>
                    <div className="card-body">
                        {data?.length === 0 &&
                            <p className='alert alert-primary fw-bold'>No Data available !</p>}
                        {isLoading &&
                            <p className='alert alert-warning'>Updating ... please wait !</p>}
                        {data?.length > 0 && <div className="table-responsive dataTablehistory">
                            <div className="dataTables_wrapper no-footer">
                                <table id="example" className="table shadow-hover dataTable display">
                                    <thead>
                                        <tr className='text-left'>
                                            <th>Action</th>
                                            <th>Task</th>
                                            <th>ID</th>
                                            <th>Sequence</th>
                                            <th>Work Segment</th>
                                            <th>Task Process</th>
                                            <th>Task Group</th>
                                        </tr>
                                    </thead>
                                    <tbody onDragOver={handleDragOver}>
                                        {data?.map((item, index) => (
                                            <tr
                                                key={index}
                                                style={{ background: draggableIndex === index && '#03a9f49e !important' }}
                                                className={`text-black text-capitalize`}
                                                draggable
                                                onDragStart={(e) => handleDragStart(e, index)}
                                                onDrop={(e) => handleDrop(e, index)}>
                                                <td>
                                                    {/* <button
                                                        className="btn btn-primary shadow btn-xs sharp me-3"
                                                        draggable
                                                        onDragStart={(e) => handleDragStart(e, index)}
                                                    >
                                                        <i className="fas fa-arrows-alt"></i> 
                                                    </button> */}
                                                    <Link
                                                        to={{ pathname: '/mapping-edit/' + item?.mhkt_id, state: item }}
                                                        className="btn btn-primary shadow btn-xs sharp me-3"
                                                        onClick={() => localStorage.setItem('edit-manage-hkt', JSON.stringify(item))}><i className="fas fa-pencil-alt"></i></Link>
                                                </td>
                                                <td>{(item?.item_task_name ? item?.item_task_name : '') +
                                                    ' ' +
                                                    (item?.item_name ? item?.item_name : '')}</td>
                                                <td>{item?.mhkt_id}</td>
                                                <td className='text-center'>{item?.sequence}</td>
                                                <td>{item?.segment_name}</td>
                                                <td>{item?.process_name}</td>
                                                <td>{item?.task_group_name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageHKT